module.exports = __webpack_public_path__ + "static/northlands-b20335b65db557bb935725d8d2e4adef.jpg";